import apiClient from '../../api/http-common';

const getTradingSlotSettingsOptions = ():any =>
  apiClient.post('/settings/trading-slot/get-options-data')

const getEditTradingSlotSettings = ():any =>
  apiClient.post('/settings/trading-slot/edit')

const createTradingSlotSettings = (data):any =>
  apiClient.post('/settings/trading-slot/update', data)

const getFileTradingSlotSettings = (data):any =>
  apiClient.post('/settings/get-file', data)

const TradingSlotSettingsService = {
  getTradingSlotSettingsOptions,
  getEditTradingSlotSettings,
  createTradingSlotSettings,
  getFileTradingSlotSettings
}

export default TradingSlotSettingsService
